import React from 'react';
import I18n from '@/modules/i18n';
import SessionPopup from '@/components/common/SessionPopup';
import Icon from '@/components/ui/Icon';

interface ConfirmSessionEndModalProps {
  modalManager: ModalManager;
}

const ConfirmSessionEndModal = ({ modalManager }: ConfirmSessionEndModalProps) => (
  <SessionPopup
    body={I18n.t('end_session_confirmation')}
    headline={{
      id: 'confirm-session-end-modal',
      text: I18n.t('session_ended_headline'),
    }}
    icon={<Icon color="tci-purple" icon="InfoAlternate" size={26} />}
    isOpen={modalManager.isOpen}
    primaryButton={{
      onClick: modalManager.close,
      text: I18n.t('close'),
      variant: 'purple',
    }}
    onClose={modalManager.close}
  />
);

export default ConfirmSessionEndModal;
